(function() {
  // Hart kodierte Predictive‑Search‑URL
  var predictiveUrl = '/search/suggest';

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.predictive-search').forEach(function(wrapper) {
      var input = wrapper.querySelector('#PredictiveSearchInput');
      var resultsContainer = document.getElementById('predictive-search-results');
      if (!input || !resultsContainer) return;

      // 0.5) Enter-Key auf Standard-Suche umleiten
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = encodeURIComponent(input.value.trim());
          window.location.href = '/search?type=product&q=' + q;
        }
      });

      // 0) Initial‑Load: vorhandenen Wert bereinigen (Prefixe, OR, Klammern, Duplikate)
      var initialRaw = input.value.trim();
      if (initialRaw.length) {
        var cleaned = initialRaw
          .replace(/title:/gi, '')
          .replace(/sku:/gi, '')
          .replace(/\s+OR\s+/gi, ' ')
          .replace(/[()]/g, '')
          .trim();
        var words = cleaned.split(/\s+/);
        var uniqueWords = words.filter(function(v,i,a){ return a.indexOf(v) === i; });
        var initialClean = uniqueWords.join(' ');
        input.value = initialClean;
        input.setAttribute('placeholder', initialClean);
      }

      // 1) Dropdown in den Input‑Container ziehen
      var inputContainer = input.parentElement;
      inputContainer.style.position = 'relative';
      inputContainer.appendChild(resultsContainer);

      // 2) Dropdown positionieren
      function styleDropdown() {
        resultsContainer.style.position  = 'absolute';
        resultsContainer.style.top       = input.offsetHeight + 'px';
        resultsContainer.style.left      = '0';
        resultsContainer.style.width     = input.offsetWidth + 'px';
        resultsContainer.style.boxSizing = 'border-box';
        resultsContainer.style.display   = 'none';
        resultsContainer.style.zIndex    = '1000';
      }
      styleDropdown();
      window.addEventListener('resize', styleDropdown);

      var controller = null;

      // 3) Input‑Event: bereinigen, Duplikate entfernen, fetch ausführen
      input.addEventListener('input', function(e) {
        var rawQuery = e.target.value.trim();
        // Prefixe, OR und Klammern raus
        var cleanQuery = rawQuery
          .replace(/title:/gi, '')
          .replace(/sku:/gi, '')
          .replace(/\s+OR\s+/gi, ' ')
          .replace(/[()]/g, '')
          .trim();
        // Duplikate entfernen
        var parts = cleanQuery.split(/\s+/);
        var unique = parts.filter(function(v,i,a){ return a.indexOf(v) === i; });
        cleanQuery = unique.join(' ');

        // Input‑Feld und Placeholder updaten
        if (cleanQuery !== rawQuery) {
          input.value = cleanQuery;
        }
        input.setAttribute('placeholder', cleanQuery);

        // ❶ Abbruch, wenn zu kurz
        if (cleanQuery.length < 2) {
          resultsContainer.innerHTML = '';
          resultsContainer.style.display = 'none';
          input.setAttribute('aria-expanded', 'false');
          return;
        }
        // ❷ laufende Anfrage abbrechen
        if (controller) controller.abort();
        controller = new AbortController();

        // ❸ SKU‑Like? Entferne alle Whitespaces, wenn Eingabe Ziffern enthält
        var queryForFetch = cleanQuery;
        if (/\d/.test(cleanQuery)) {
          queryForFetch = cleanQuery.replace(/\s+/g, '');
        }

        // URL mit SKU‑Feld erweitern
        var url = predictiveUrl
                + '?q=' + encodeURIComponent(queryForFetch)
                + '&resources[type]=product'
                + '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku'
                + '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function(res) {
            if (!res.ok) throw new Error('Status ' + res.status);
            return res.text();
          })
          .then(function(html) {
            resultsContainer.innerHTML = html;
            resultsContainer.style.display = 'block';
            input.setAttribute('aria-expanded', 'true');
            input.focus({ preventScroll: true });
          })
          .catch(function(err) {
            if (err.name !== 'AbortError') {
              console.error('PredictiveSearch Fetch Error:', err);
            }
          });
      });

      // 4) Klick außerhalb schließt das Dropdown
      document.addEventListener('click', function(e) {
        if (!wrapper.contains(e.target)) {
          resultsContainer.style.display = 'none';
          input.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
})();